import $ from "jquery";
import {Swiper, Navigation, Pagination, EffectFade, Lazy, Autoplay, Thumbs} from "swiper/swiper.esm";

window.jQuery = $
window.$ = $
// window.is = is


Swiper.use([Swiper, Navigation, Pagination, EffectFade, Lazy, Autoplay, Thumbs]);

// require("./jquery.fancybox.js");

document.addEventListener('DOMContentLoaded', () => {
	$("body").on("mousedown", "select:not(.no-my-select)", function(e){
		const $this = $(this);
	
		if (is.touchDevice()) return;
	
		e.preventDefault();
		
		if (this.classList.contains("my-select"))
			$this.closest("div").find(".my-select__list-cont").remove();
		
		const select = window.selectInitial(this);
	
		this.classList.add("my-select");
		this.closest("div").style.position = "relative";
	
		$this.addClass("js__opened");
	});
});

let bodyPosition = 0;

$(window).on("load", function(){

	if(document.querySelector('.main-slider')){

		const mainSlider = document.querySelector('.main-slider .swiper-list');

		new Swiper (mainSlider, {
			slidesPerView: 1,
			centeredSlides: true,
			loop: true,
			initialSlide: 1,
			autoplay: true,
			spaceBetween: 25,
		})
	}

	const restSlider = document.querySelector('.about__photos .swiper-container')

	if (restSlider) {
		new Swiper (restSlider, {
			slidesPerView: 2.2,
			spaceBetween: 16,
			navigation: {
				prevEl: '.about__photos .swiper-button-prev',
				nextEl: '.about__photos .swiper-button-next',
			},
		})
	}

	// loader
	// setTimeout(function(){
	// 	document.querySelector('.loading').classList.add('loaded');
	// }, 300)
	
	// setTimeout(function(){
	// 	document.querySelector('.loading').classList.remove('loading');
	// }, 600)
	
	// setTimeout(function(){
	// 	document.querySelector('.loaded').classList.add('loaded-end');
	// }, 1000)
	

	// подсвечивание пункта меню
	document.addEventListener('scroll', () => {
		let dataId;
		$('.catalog-list').each(function(){
			if($(this).offset().top<$(window).scrollTop() + 160){
				dataId = $(this).attr('id');
			}
		});
		$('.nav__link').parent('.nav__item').removeClass('active');
		$('.nav__link[href="#'+dataId+'"]').parent('.nav__item').addClass('active');

		scrollMobNav();

	});

	let scrollMobNav = function() {
		// скролл к активной ссылке в навигации
		if($(".head-nav--mobile .nav__list .active").length >= 1) {

			let containerOuterWidth = $('.head-nav--mobile .nav__list').outerWidth(); // узнаем ширину контейнера (width + padding)

			let itemOuterWidth = $('.head-nav--mobile .nav__list .nav__item.active').outerWidth(); // узнаем ширину текущего элемента (width + padding)
			let itemOffsetLeft = $('.head-nav--mobile .nav__list .nav__item.active').offset().left; // узнаем значение отступа слева в контейнере у текущего элемента
			let containerScrollLeft = $(".head-nav--mobile .nav__list").scrollLeft(); // узнаем текущее значение скролла

			let positionCetner = (containerOuterWidth / 2 - itemOuterWidth / 2); // рассчитываем позицию центра

			let scrollLeftUpd = containerScrollLeft + itemOffsetLeft - positionCetner; // рассчитываем положение скролла относительно разницы отступа элемента и центра контейнера

			// анимируем
			$('.head-nav--mobile .nav__list').animate({
				scrollLeft: scrollLeftUpd
				},{
				queue: false // не ставим в очередь
			});
		}
	}

	// скролл по якорным ссылкам
	$('.nav__link').on( 'click', function(){ 
		let el = $(this);
		let dest = el.attr('href'); // получаем направление
		if(dest !== undefined && dest !== '') { // проверяем существование
			console.log($(dest).offset().top);
			$('html,body').animate({ 
				scrollTop: $(dest).offset().top - 150 // прокручиваем страницу к требуемому элементу
			}, 400 // скорость прокрутки
			);
		}
		return false;
	});

	// toggle-theme
	//retrieve current state
	$('.page-catalog, .page-about').addClass(window.localStorage.toggled);

	/* Toggle */
	$('.toggle-theme').on('click',function(){

		if (window.localStorage.toggled != "light-theme" ) {
			$('body').toggleClass("light-theme", true );
			window.localStorage.toggled = "light-theme";
		} else {
			$('body').toggleClass("light-theme", false );
			window.localStorage.toggled = "";
		}

	});

});


$(window).on("load scroll resize", e => {

	let offset = $(".head").height();
	
	if ($(window).scrollTop() >= 300){
	
		$(".head-nav--mobile").addClass("js__scrolled");
		$("body").addClass("js__scroll");
		
		setTimeout(e => {
			$(".head").addClass("js__show")
		}, 300);
		
	}else{
		$("body").removeClass("js__scroll");
		$(".head-nav--mobile").removeClass("js__scrolled").removeClass("js__show");
		
	}
	
})
